module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/fullDeal-3fc97ca242c2d63d3c1378a1470d2202.png";